// extracted by mini-css-extract-plugin
module.exports =  {"wells":"OLU18jmfXEokUKZvszTi"};